import { useQuery } from "@tanstack/react-query";
import { useTheme } from "styled-components";
import MetricsAPI from "@/api/Metrics/Metrics.js";
import moment from "moment";
import { timezone } from "@/utils/timezoneResolver";
import { Client } from "@/types";
import DenseBarChart from "./DenseBarChart";

export interface TopClient extends Pick<Client, "client_id" | "name"> {
  email: string; // Require
  organization: string; // Require
  total_cases: number; // Additional field for TopClient
}

const TopClientsWidget = () => {
  const theme: any = useTheme();

  const { data: topClientsData } = useQuery({
    queryKey: ["metrics:topClients"],
    queryFn: () =>
      MetricsAPI.getMetrics({
        metric: "topClients",
        args: [
          timezone,
          moment().subtract(6, "months").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
          5,
        ],
      }),
    select: (data) => data?.data?.topClients,
  });

  if (!topClientsData) return null;

  const sorted = [...topClientsData].sort(
    (a: TopClient, b: TopClient) => b.total_cases - a.total_cases
  );

  return (
    <DenseBarChart
      labels={sorted.map(
        (client: TopClient) => `${client.name} (${client.organization})`
      )}
      values={sorted.map((client: TopClient) => client.total_cases)}
      seriesName="Total Cases"
      color={theme.palette.success.main}
    />
  );
};

export default TopClientsWidget;
